import React from 'react';
import {
    Container,
    Title,
    Text,
    TitleProps,
    Button,
} from '@soluto-design/react';
import Form, { FormProps } from '../../molecules/Form';

import cls from '@soluto-design/styles/cls';

export interface BlockDemoSectionProps {
    title?: string;
    titleTag?: TitleProps['component'];
    text?: string;
    form?: FormProps;
    positionForm: 'default' | 'bot-top';
    className?: string;
    ctaText?: string;
    anchor?: boolean;
}

export default function BlockDemoSection({
    title,
    titleTag = 'h2',
    text,
    form,
    className,
    positionForm = 'default',
    ctaText,
    anchor,
}: BlockDemoSectionProps) {
    const isMobile = positionForm === 'bot-top';

    return (
        <section className={cls('pt-xxl pb-xxxl relative', className)}>
            {!!anchor && <div id="form" className="absolute top-[-48px]" />}
            <Container>
                {isMobile && (
                    <div className="lg:hidden">
                        {!!title && (
                            <Title
                                component={titleTag}
                                isHtml
                                className="text-h200 text-text-primary mb-32 text-balance">
                                {title}
                            </Title>
                        )}
                        {!!text && (
                            <Text
                                isHtml
                                component="div"
                                className="text-b400 text-text-secondary mb-xl [&>h2]:text-b300 [&>h2]:text-text-primary [&>h2]:mb-16 [&>h3]:text-b300 [&>h3]:text-text-primary [&>h3]:mb-16 [&>h4]:text-b300 [&>h4]:text-text-primary [&>h4]:mb-16 unordered-list-items text-spacers [&_ul]:!mt-lg blockquote-list-icon [&_blockquote]:!mt-lg">
                                {text}
                            </Text>
                        )}
                        {!!ctaText && (
                            <Button variant="primary" size="large" href="#form">
                                {ctaText}
                            </Button>
                        )}
                    </div>
                )}
                <div
                    className={cls(
                        'row relative rounded-large bg-background-secondary overflow-hidden',
                        isMobile && 'hidden lg:grid',
                    )}>
                    <div className="absolute w-full h-full top-[60%] left-[70%] lg:left-[60%] xl:left-[70%] hd:left-[60%] md:top-0 md:bg-left bg-block-demo-shape bg-no-repeat bg-block-demo-shape-xs md:bg-block-demo-shape-md xl:bg-block-demo-shape-xl" />
                    <div className="z-10 col-span-full md:col-span-6 lg:col-span-5 xl:col-span-7 hd:col-span-6 m-24 md:m-72 md:mr-0 xl:m-96 xl:mr-0">
                        {!!title && (
                            <Title
                                component={titleTag}
                                isHtml
                                className="text-h200 text-text-primary pb-lg text-balance">
                                {title}
                            </Title>
                        )}
                        {!!text && (
                            <Text
                                isHtml
                                component="div"
                                className="text-b400 text-text-secondary pb-xg [&>h2]:text-b300 [&>h2]:text-text-primary [&>h2]:mb-16 [&>h3]:text-b300 [&>h3]:text-text-primary [&>h3]:mb-16 [&>h4]:text-b300 [&>h4]:text-text-primary [&>h4]:mb-16 unordered-list-items [&_p]:my-[24px] [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 [&_ul]:!mt-lg blockquote-list-icon [&_blockquote]:!mt-lg">
                                {text}
                            </Text>
                        )}
                        {form && <Form {...form} />}
                    </div>
                </div>
            </Container>
        </section>
    );
}
